<div class="email-dialog">
    <form autocomplete="off" novalidate [formGroup]="searchForm">

        <div class="dialog-header">
            <div class="title-block">
                <i class="fas fa-envelope header-icon"></i>
                <div class="ml-2">
                    <h3 class="main-content-label mb-1"><b>Send Email to Examiners</b></h3>
                    <p class="text-muted card-sub-title mb-0">
                        {{ showProgress ? 'Generating letters and sending emails one by one' : 'Select examiners and
                        send notification email' }}
                    </p>
                </div>
            </div>

            <div class="filter-block" *ngIf="!showProgress">
                <mat-form-field appearance="outline" class="search-field">
                    <mat-label>Search</mat-label>
                    <input matInput placeholder="Search name, mobile, email" formControlName="SearchString">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Filter</mat-label>
                    <mat-select formControlName="Designation">
                        <mat-option *ngFor="let d of designationList" [value]="d.value">
                            {{ d.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <ng-container *ngIf="!showProgress">
            <div class="action-bar">
                <div class="selection-block">
                    <span class="selected-count">Selected: {{ getSelectedCount() }}</span>
                    <button id="SelectAll" type="button" class="btn btn-outline-primary btn-icon-text"
                        [disabled]="totalItems === 0 || loading || selectingAll" (click)="selectAllRecords()">
                        <span class="btn-inner">
                            <i class="fas" style="margin-right: 7px;"
                                [ngClass]="selectingAll ? 'fa-spinner fa-spin' : (allRecordsSelected ? 'fa-times-circle' : 'fa-check-double')"></i>
                            {{ allRecordsSelected ? 'Clear All' : 'Select All (' + totalItems + ')' }}
                        </span>
                    </button>
                </div>

                <button id="Send" type="button" class="btn btn-primary btn-icon-text"
                    [disabled]="getSelectedCount() === 0 || selectingAll" (click)="sendEmail()">
                    <span class="btn-inner">
                        <i class="fas fa-paper-plane" style="margin-right: 7px;"></i>
                        Send
                    </span>
                </button>
            </div>

            <div class="table-container">
                <div class="loading-bar" *ngIf="loading"></div>

                <table id="datatable" class="table table-bordered text-nowrap text-left" [class.is-loading]="loading">
                    <thead>
                        <tr>
                            <th class="text-center col-check">
                                <mat-checkbox [checked]="allSelectedOnPage" [indeterminate]="someSelectedOnPage"
                                    [disabled]="teacherList.length === 0"
                                    (change)="toggleAllOnPage($event.checked)"></mat-checkbox>
                            </th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Email</th>
                            <th>Assigned College</th>
                            <th>Course</th>
                            <th>Subject</th>
                            <th>Assigned As</th>
                            <th>Email/Sms Send</th>
                        </tr>
                    </thead>
                    <tbody id="table_data">
                        <tr *ngFor="let t of teacherList">
                            <td class="text-center col-check">
                                <mat-checkbox [checked]="isSelected(t)"
                                    (change)="toggleRow(t, $event.checked)"></mat-checkbox>
                            </td>
                            <td>{{ t.TeacherName }}</td>
                            <td>{{ t.MobileNo }}</td>
                            <td>{{ t.Email }}</td>
                            <td>{{ t.AssignedCollege }}</td>
                            <td>{{ t.CoName }}</td>
                            <td>{{ t.EsName }}</td>
                            <td>{{ t.AssignedAs }}</td>
                            <td>
                                <span [ngClass]="t.EmailSmsSend ? 'status-badge sent' : 'status-badge not-sent'">
                                    {{ t.EmailSmsSend ? 'Sent' : 'Not Sent' }}
                                </span>
                            </td>
                        </tr>
                        <tr *ngIf="!loading && teacherList.length === 0">
                            <td colspan="8" class="text-center">No Data Found</td>
                        </tr>
                        <tr *ngIf="loading && teacherList.length === 0">
                            <td colspan="8" class="text-center text-muted">Loading...</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageIndex]="currentPage - 1"
                [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)"></mat-paginator>
        </ng-container>

        <div class="progress-panel" *ngIf="showProgress">
            <div class="progress-summary">
                <div class="stat">
                    <span class="stat-value">{{ results.length }}</span>
                    <span class="stat-label">Total</span>
                </div>
                <div class="stat sent">
                    <span class="stat-value">{{ sentCount }}</span>
                    <span class="stat-label">Sent</span>
                </div>
                <div class="stat failed">
                    <span class="stat-value">{{ failedCount }}</span>
                    <span class="stat-label">Failed</span>
                </div>
                <div class="stat">
                    <span class="stat-value">{{ remainingCount }}</span>
                    <span class="stat-label">Remaining</span>
                </div>
            </div>

            <div class="progress-track">
                <div class="progress-fill" [style.width.%]="progressPercent"></div>
            </div>

            <div class="progress-caption">
                <span>{{ completedCount }} of {{ results.length }} processed ({{ progressPercent }}%)</span>
                <span *ngIf="currentItem">
                    {{ statusLabels[currentItem.status] }}: <b>{{ currentItem.name }}</b>
                </span>
                <span *ngIf="!sending && results.length > 0">Completed</span>
            </div>

            <div class="table-container">
                <table class="table table-bordered text-nowrap text-left">
                    <thead>
                        <tr>
                            <th class="col-index">#</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Email</th>
                            <th>Assigned College</th>
                            <th>Subject</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of results; let i = index">
                            <td class="col-index">{{ i + 1 }}</td>
                            <td>{{ r.name }}</td>
                            <td>{{ r.designation }}</td>
                            <td>{{ r.email }}</td>
                            <td>{{ r.college }}</td>
                            <td>{{ r.subject }}</td>
                            <td>
                                <span class="status-badge" [ngClass]="'status-' + r.status">
                                    <i class="fas" [ngClass]="statusIcons[r.status]"></i>
                                    {{ statusLabels[r.status] }}
                                </span>
                                <span class="result-message" *ngIf="r.message">{{ r.message }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="dialog-footer">
            <ng-container *ngIf="showProgress">
                <button id="Stop" type="button" class="btn btn-danger btn-icon-text" *ngIf="sending"
                    (click)="stopSending()">
                    <span class="btn-inner">
                        <i class="fas fa-stop" style="margin-right: 7px;"></i>
                        Stop
                    </span>
                </button>
                <button id="Retry" type="button" class="btn btn-outline-primary btn-icon-text"
                    *ngIf="!sending && failedCount > 0" (click)="retryFailed()">
                    <span class="btn-inner">
                        <i class="fas fa-redo" style="margin-right: 7px;"></i>
                        Retry Failed ({{ failedCount }})
                    </span>
                </button>
                <button id="Back" type="button" class="btn btn-outline-primary btn-icon-text" *ngIf="!sending"
                    (click)="backToList()">
                    <span class="btn-inner">
                        <i class="fas fa-arrow-left" style="margin-right: 7px;"></i>
                        Back to List
                    </span>
                </button>
            </ng-container>

            <button id="Close" type="button" class="btn btn-primary btn-icon-text" [disabled]="sending"
                (click)="close()">
                <span class="btn-inner">
                    <i class="fas fa-times" style="margin-right: 7px;"></i>
                    Close
                </span>
            </button>
        </div>
    </form>
</div>